import PaymentDataModeFirst from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentDataModeFirst";
import { connect } from "react-redux";
import {
	calculatePartialPaymentAmount,
	checkIfPaymentAlmaAvailable,
	checkIfPaymentFloaAvailable,
	checkIfPaymentPledg4xDisponible,
	getAllowedPaymentTypes,
	getBookingPaymentMode,
	getBookingPaymentType,
	getPaymentModes,
	getSupportedPaymentTypes,
} from "app/pages/Booking/Payment/paymentSelector";
import {
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { bindActionCreators } from "redux";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";

import { FormattedMessage } from "react-intl";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import {
	getOnlyNonApplicableCreditNotes,
	getOrderedUnusableCreditNotes,
	getOrderedUsableCreditNotes,
	getUsableCreditNotesTotal,
} from "app/pages/Account/MyCoupons/couponSelector";

const mapStateToProps = state => {
	const total = getQuoteTotalWithDelta(state);

	// TODO 4x rendre generique
	const isPaiementPledg4xAvailable = checkIfPaymentPledg4xDisponible(state);
	const isPaymentAlmaAvailable = checkIfPaymentAlmaAvailable(state);
	const isPaymentFloaAvailable = checkIfPaymentFloaAvailable(state);

	return {
		booking: state.booking,
		selectedPaymentMode: getBookingPaymentMode(state),
		selectedPaymentType: getBookingPaymentType(state),
		paymentTypes: getSupportedPaymentTypes(state),
		allowedPaymentTypeOfSelectedTerm: getAllowedPaymentTypes(state),
		paymentModes: getPaymentModes(state),
		total: total,
		isPaiementPledg4xAvailable,
		isPaymentAlmaAvailable: isPaymentAlmaAvailable,
		isPaymentFloaAvailable: isPaymentFloaAvailable,
		mensualite2Fois: calculatePartialPaymentAmount(state),
		swissbilling: {
			forbiddenCause:
				total > state.payment?.paymentSwissbilling?.maxAmount ? (
					<FormattedMessage
						id="error.payment.swissbilling.max.error"
						values={{ maxAmount: state.payment?.paymentSwissbilling?.maxAmount }}
					/>
				) : (
					false
				),
			cgvURL: state.documents.payment.swissbillingCGV,
			maxAmount: state.payment?.paymentSwissbilling?.maxAmount,
		},
		isDepositEnabled: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		usableCreditNotes: getOrderedUsableCreditNotes(state),
		unusableCreditNotes: getOrderedUnusableCreditNotes(state),
		onlyNonApplicableCreditNotes: getOnlyNonApplicableCreditNotes(state),
		totalUsableCreditNote: getUsableCreditNotesTotal(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			updateBooking,
		},
		dispatch
	);
};

export const PaymentDataModeFirstContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentDataModeFirst);
